import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTable, useSortBy, usePagination, useGlobalFilter } from "react-table";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import { faCheckCircle, faEdit, faEllipsisV, faEye, faPen, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import moment from "moment";
const UnusableProductionList = ({ permissions }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [data, setData] = useState([]);
    // Fetch productions
    const fetchProductions = async () => {
        try {
            const response = await apiClient.get(`${SERVER_BASE}/getUnusableProductions`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setData(response.data);
        } catch (error) {
            console.error("Error fetching productions:", error);
        }
    };

    useEffect(() => {
        fetchProductions();
    }, []);
    const handleDelete = async (id) => {
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "This conversion will be permanently deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
        });

        if (!confirmResult.isConfirmed) return;

        try {
            await apiClient.delete(`${SERVER_BASE}/delete-item-conversion/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            Swal.fire({
                toast: true,
                icon: "success",
                title: "Conversion deleted successfully",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });

            fetchProductions(); // Refresh list after deletion
        } catch (error) {
            console.error("Error deleting conversion:", error);
            Swal.fire({
                toast: true,
                icon: "error",
                title: "Error deleting conversion",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });
        }
    };

    // Columns configuration
    const columns = React.useMemo(
        () => [
            {
                Header: 'S.No',
                Cell: ({ row }) => row.index + 1,

            },
            {
                Header: "Date",
                accessor: (row) => row.date ? moment(row.date).format('DD-MMM-YY') : '',
            },
            {
                Header: "Department",
                accessor: (row) => row.department,
            },
            // {
            //     Header: "Consumption",
            //     accessor: (row) => row.fromItems.map((f) => f.itemName).join(", "),
            // },
            // {
            //     Header: "Production",
            //     accessor: (row) => row.toItems.map((t) => t.itemName).join(", "),
            // },
            // {
            //     Header: "Prod. Qty",
            //     accessor: (row) => row.toItems.map((t) => t.quantity).join(", "),
            // },
            {
                Header: "Status",
                accessor: (row) => row.status,
            },
            {
                Header: 'Preview', accessor: 'Preview', Cell: ({ row }) => {
                    return (
                        permissions?.read &&
                        <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() =>
                                navigate("../../UnusableProductionPreview", { state: { id: row.original.id } })
                            }
                        >
                            View
                        </button>
                    )
                }
            },
            {
                Header: "#",
                accessor: "actions",
                Cell: ({ row }) => {
                    return (
                        <div className="dropdown">
                            {/* {permissions?.read && (
                                  
                                        <button
                                            className="btn btn-sm btn-outline-success"
                                            onClick={() =>
                                                navigate("../../UnusableProductionPreview", { state: { id: row.original.id } })
                                            }
                                        >
                                            View
                                        </button>
                                 )
                                } */}
                            <button
                                className="btn btn-light btn-sm"
                                type="button"
                                id={`dropdownMenuButton-${row.index}`}
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </button>

                            <ul className="dropdown-menu dropdown-menu-end">

                                {/* Edit */}
                                {(row.original.status != 'Approved' && permissions?.edit) && (
                                    <li>
                                        <button
                                            className="dropdown-item"
                                            onClick={() =>
                                                navigate("../UnusableProduction", { state: { editData: row.original } })
                                            }
                                        >
                                            <FontAwesomeIcon icon={faEdit} /> Edit
                                        </button>
                                    </li>
                                )}
                                <li><hr /></li>

                                {/* Created By / Updated By */}
                                <li>
                                    <span className="dropdown-item-text text-muted">
                                        <FontAwesomeIcon icon={faPlus} /> {row.original.createdAt ? `${row.original.createdByName} (${row.original.createdAt ? moment(row.original.createdAt).format('DD-MMM-YY hh:mm A') : ''})` : ''}
                                    </span>
                                </li>
                                {row.original.updatedAt && (
                                    <li>
                                        <span className="dropdown-item-text text-muted">
                                            <FontAwesomeIcon icon={faPen} /> {row.original.updatedAt ? `${row.original.updatedBy} (${row.original?.updatedAt ? moment(row.original?.updatedAt).format('DD-MMM-YY hh:mm A') : ''})` : ''}
                                        </span>
                                    </li>
                                )}
                                {row.original.approvedAt && (
                                    <li>
                                        <span className="dropdown-item-text text-muted">
                                            <FontAwesomeIcon icon={faCheckCircle} /> {row.original.approvedAt ? `${row.original.approvedBy} (${row.original?.approvedAt ? moment(row.original?.approvedAt).format('DD-MMM-YY hh:mm A') : ''})` : ''}
                                        </span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    );
                }
            }

        ],
        [navigate, permissions]
    );

    // Table instance with search, sort, and pagination
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        state,
        setGlobalFilter,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 20 },
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const { globalFilter, pageIndex, pageSize } = state;

    return (
        <div className="formcontainer mt-5">

            <h4>Unusable Productions</h4>
            <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
                {permissions?.write && (
                    <button
                        className="btn btn-outline-success flex-shrink-0"
                        onClick={() => navigate("../UnusableProduction")}
                    >
                        Add Production
                    </button>
                )}

                {permissions?.read && (
                    <>
                        <input
                            value={globalFilter || ""}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            className="form-control flex-grow-1"
                            placeholder="Search by item..."
                        />

                        <select
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="form-select  flex-grow-0"
                            style={{ width: "auto" }}
                        >
                            {[20, 30, 50, 100].map((size) => (
                                <option key={size} value={size}>
                                    Show {size}
                                </option>
                            ))}
                        </select>
                    </>
                )}
            </div>

            {permissions?.read && (<>
                {/* Table */}
                <table
                    className="table table-striped table-bordered"
                    {...getTableProps()}
                    style={{ fontSize: '13px' }}
                >
                    <thead className="table-light">
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        style={{ cursor: "pointer", }}
                                    >
                                        {column.render("Header")}
                                        <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? " 🔽"
                                                    : " 🔼"
                                                : ""}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {page.length > 0 ? (
                            page.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map((cell) => (
                                            <td
                                                {...cell.getCellProps()}
                                                style={{ verticalAlign: "middle" }}
                                            >
                                                {cell.render("Cell")}
                                            </td>
                                        ))}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className="text-center">
                                    No productions found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                {/* Pagination Controls */}
                <div className="d-flex align-items-center mb-3">
                    {/* Previous – left corner */}
                    <button
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                        className="btn btn-secondary me-auto"
                        style={{ minWidth: 110 }}   // keeps width consistent
                    >
                        Previous
                    </button>

                    {/* Center block for page index & size selector */}
                    <div className="text-center flex-grow-1 d-flex flex-column align-items-center">
                        {/* Row 1: Page index and size selector in one line */}
                        <div className="d-flex align-items-center gap-3">
                            <div className="fw-semibold">
                                Page {pageIndex + 1} of {pageOptions.length}
                            </div>


                        </div>
                    </div>


                    {/* Next – right corner */}
                    <button
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                        className="btn btn-secondary ms-auto"
                        style={{ minWidth: 110 }}
                    >
                        Next
                    </button>
                </div>
            </>)}
        </div>
    );
};

export default UnusableProductionList;
